var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag)?_c('section',{directives:[{name:"qa",rawName:"v-qa",value:("ds_warning_section"),expression:"`ds_warning_section`"}],staticClass:"warning"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.translationTag)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }